module.exports = __webpack_public_path__ + "img/htkj_19.1e2d949a.jpg";